export default function openInNewTab(url) {
  window.open(url, "_blank", "noopener, noreferrer");
}